import { BasePage } from "@Tenants/Hw/Site/BasePage";
import { ReadMore } from "@Utilities/ReadMore";
import { Media } from '@Utilities/Media';
import debounce from "debounce";
import enquire from 'enquire.js';

import "@Base/Home/_Bubbles.scss";
import "./Home.scss";

class HomePage extends BasePage
{
	private Carousel = document.querySelector(".carousel");
	private CarouselContainer = document.querySelector(".carousel__container");
	private CarouselItems: NodeListOf<HTMLElement> = document.querySelectorAll(".carousel__item");
	private CarouselDots = document.querySelectorAll(".carousel__dots li");

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.ConfigureReadMore();

		if (this.Carousel !== null)
		{
			this.ConfigureCarousel();
		}
	};

	private ConfigureReadMore = (): void =>
	{
		const readClamp: HTMLElement = document.querySelector(".readClamp");

		if (readClamp !== null)
		{
			new ReadMore(readClamp);
		}
	};

	private ConfigureCarousel = (): void =>
	{
		enquire.register(Media.MediaMobile, {
			deferSetup: true,
			match: (): void =>
			{
				if (this.CarouselDots.length)
				{
					this.CarouselDots.forEach((dot) =>
					{
						dot.addEventListener("click", this.CarouselDotHandler);
					});

					this.CarouselContainer.addEventListener("scroll", this.CarouselScrollHandler);
				}
			},
			unmatch: (): void =>
			{
				if (this.CarouselDots.length)
				{
					this.CarouselDots.forEach((dot) =>
					{
						dot.removeEventListener("click", this.CarouselDotHandler);
					});

					this.CarouselContainer.removeEventListener("scroll", this.CarouselScrollHandler);
				}
			}
		});
	};

	private CarouselDotHandler = (e: Event): void =>
	{
		const clicked = e.currentTarget as HTMLElement;
		const clickedIndex = [].indexOf.call(clicked.parentElement.children, clicked) as number;
		const item = this.CarouselItems[clickedIndex];

		this.CarouselContainer.scroll({
			left: item.offsetLeft,
			behavior: "smooth"
		});
	};

	private CarouselScrollHandler = debounce((e: Event) =>
	{
		const scrollLeft = this.CarouselContainer.scrollLeft;

		// Account for overscroll on mobile
		if (!(scrollLeft < 0))
		{
			const scrollWidth = parseFloat(getComputedStyle(this.CarouselContainer).width.replace("px", ""));
			const index = Math.floor(scrollLeft / scrollWidth);

			// Again account for overscroll on mobile
			if (index < this.CarouselDots.length)
			{
				(this.Carousel.querySelector(".carousel__dots li.active")).classList.remove("active");
				this.CarouselDots[index].classList.add("active");
			}
		}
	}, 100);
}

const home = new HomePage();